"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Icon_1 = require("@material-ui/core/Icon");
const Link_1 = require("@material-ui/core/Link");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const HistoryScreenStyle_1 = require("./jss/HistoryScreenStyle");
const RewardData = ({ reward, classes, t }) => {
    const downloadFile = (fileUrl) => {
        window.open(fileUrl);
        return fileUrl;
    };
    if (reward.codes && reward.codes.length) {
        return ((0, jsx_runtime_1.jsxs)("span", { children: [t('history.rewardsTab.codes'), reward.codes.map(codeData => ' ' + codeData.code)] }));
    }
    else if (!!reward.digital_download) {
        return ((0, jsx_runtime_1.jsxs)(Link_1.default, Object.assign({ component: 'a', className: (0, classnames_1.default)(classes.link, 'linkButton'), underline: "none", onClick: downloadFile.bind(this, reward.digital_download) }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: classes.underline }, { children: t('history.rewardsTab.digitalDownload') })), (0, jsx_runtime_1.jsx)(Icon_1.default, Object.assign({ color: "inherit", className: (0, classnames_1.default)('file_download', classes.downloadIcon) }, { children: "file_download" }))] })));
    }
    return null;
};
exports.default = (0, core_1.withStyles)(HistoryScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(RewardData));
//# sourceMappingURL=RewardData.js.map